import "./index.css";
import { StrictMode, useEffect, useState, useRef } from "react";
import { createRoot } from "react-dom/client";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";
// import Sidebar from "./Components/Sidebar.jsx";
import Sidebar from "./Components/SideBarComponent.jsx";
// import { UserContextProvider } from "./Context/DealerProfile.jsx";
// import { UserContextProvider } from "./Context/DealerProfile.jsx";r
import { UserContextProvider } from "./Context/UserProfile.jsx";
import Vendor from "./pages/vendorPages.jsx";
import VendorEdit from "./pages/VendorEdit.jsx";
import VendorDetails from "./pages/VendorDetails.jsx";

function App() {
  return (
    <StrictMode>
      <UserContextProvider>
        <BrowserRouter basename="/app">
          <div className="h-full w-full flex overflow-hidden overflow-x-hidden">
            <Sidebar />
            <div className="flex-1 h-screen overflow-x-hidden pl-4 box-border rounded-tl-[0px] bg-[#F1F2F7]">
              <Routes>
                <Route path="/" element={<Navigate to="/Vendor" />} />
                <Route path="/index.html" element={<Navigate to="/Vendor" />} />
                <Route path="/Vendor" element={<Vendor />} />
                <Route path="/vendor-details/:id" element={<VendorDetails />} />
             <Route path="/edit-vendor/:id" element={<VendorEdit />} />
              </Routes>
            </div>
          </div>
        </BrowserRouter>
      </UserContextProvider>
    </StrictMode>
  );
}

createRoot(document.getElementById("root")).render(<App />);
